import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Dropdown, Option } from "./Dropdown";
import { Form, Button } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import Toggle from "react-toggle";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

const MySwal = withReactContent(Swal);

const ViewSubscriptions = ({ history, match }) => {
  const [users, setUsers] = useState({});
  const [dap_name, setName] = useState("");
  const [dap_date, setDate] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_package, setPackage] = useState("");
  const [dap_userNo, setUserNo] = useState("");
  const [dap_price, setPrice] = useState("");
  const [dap_dob, setDOB] = useState("");
  const [dap_billable, setBillable] = useState(false);
  const [dap_billable1, setBillable1] = useState(false);
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [region, setRegion] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [toggleChecked, setToggleChecked] = useState(false);
  const [phoneErrors, setPhoneErrors] = useState({});
  const dap_user_id = match.params.id;
  const toggle = (e) => {
    setToggleChecked(true);
  };

  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  states = State.getAllStates();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };

  //   console.log(Country.getAllCountries());
  //   console.log(Country.getAllCountries());
  //   console.log(State.getAllStates());
  useEffect(() => {
    let id = match.params.id;
    //  console.log(id);getLead(id);
    setLoading(true);
    console.log(id);
    axios
      .get(environment.dap_url + "crm_api/getSubscriberById?id=" + id)
      .then((res) => {
        const dap_users = res.data;
        console.log(res);
        console.log("hello");
        setUsers(res.data);
        setEmail(res.data.email);
        setName(res.data.name);
        setPhone(res.data.phone);
        setPackage(res.data.package);
        setPrice(res.data.price);
        setUserNo(res.data.userNumber);
        // setPostCity(res.data.city);
        setDate(res.data.date);
        console.log(res.data.email);
        // setLoader(false);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const formValidation = () => {
    const emailErrors = {};
    const nameErrors = {};
    const phoneErrors = {};

    let isValid = true;

    if (!dap_email) {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(dap_email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    }
    if (!dap_name) {
      nameErrors.noName = "* Name is required";
      isValid = false;
    } else if (dap_name.trim().length < 2) {
      nameErrors.shortName = "* First Name is too short";
      isValid = false;
    }
    if (!dap_phone) {
      phoneErrors.shortNumber = "* Phone number required";
      isValid = false;
    } else if (dap_phone.trim().length < 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (dap_phone.trim().length > 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,1024}$/.test(
        dap_phone
      )
    ) {
      phoneErrors.shortNumber = "Phone number should be 10 digits";
      isValid = false;
    }

    setEmailErrors(emailErrors);
    setNameErrors(nameErrors);
    setPhoneErrors(phoneErrors);
    return isValid;
  };

  const submitHandler = (e) => {
    const isValid = formValidation();
    e.preventDefault();
    setLoading(true);
    let id = match.params.id;
    console.log(id);
    axios
      .put(
        //"user?sendActivationMail=true",
        environment.dap_url + "crm_api/updateLead?id=" + id,
        {
          // id: match.params.id,
          name: dap_name,
          email: dap_email,
          phone: dap_phone,
          date: dap_date,
          package: dap_package,
          price: dap_price,
          userNumber: dap_userNo,
          //   userType: "LOGISTIC_MANAGER",
        }
      )
      .then((res) => {
        console.log("hello", res.data);
        history.push("/subscriptions");
        MySwal.fire({
          title: <p>Lead has been successfully updated!</p>,
          type: "success",
        });
        //   history.push(`/users/${dap_user_id}`);
      })
      .catch((err) => {
        setLoading(false);
        MySwal.fire({
          title: <p>{err?.response?.data?.message || "Lead update failed"}</p>,
          type: "error",
        });
      });
  };

  return (
    <div>
      <div className="row" style={{ marginTop: "75px", color: "black" }}></div>

      <div className="container">
        <div class="col-md-12">
          <Link
            to="/subscriptions"
            className="btn btn-light my-3"
            style={{ marginLeft: 770 }}
          >
            Go Back
          </Link>
        </div>
      </div>

      <div style={{ marginTop: "2%" }} className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h4>Subscriber Details</h4>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th scope="row">Name</th>

                      <td>{dap_name}</td>
                    </tr>
                    {/* <tr>
                      <th scope="row">Date</th>
                      <td>{dap_date}</td>
                    </tr> */}
                    <tr>
                      <th scope="row">Email</th>
                      <td>{dap_email}</td>
                    </tr>
                    <tr>
                      <th scope="row">Phone</th>
                      <td>{dap_phone}</td>
                    </tr>
                    <tr>
                      <th width="50%" scope="row">
                        Package
                      </th>
                      <td>{dap_package}</td>
                    </tr>
                    <tr>
                      <th scope="row">Price</th>
                      <td>{dap_price}</td>
                    </tr>
                    <tr>
                      <th scope="row">User Number</th>
                      <td>{dap_userNo}</td>
                    </tr>

                    {/* <tr>
                      <th scope="row">Billable</th>
                      <td>
                        {dap_billable}
                        <Toggle
                          id="cheese-status"
                          //   checked={dap_billable}
                          //   disabled={true}
                          //   onChange={(e) => toggle(e)}
                        />
                      </td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSubscriptions;
